import { all, call } from "redux-saga/effects";
import { cashInOutSagas } from "./cash-in-out/cash-in-out-saga";
import { sagas } from "./general/saga";

export default function* rootSaga() {
  yield all([call(cashInOutSagas), call(sagas)]);
}
